<footer>
  <div class="top">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">

          <nav class="nav flex-column">
            <h6 class="nav-link p-t-2">Festivals</h6>
            <a class="nav-link" href="http://www.joyofjazz.co.za" target="_blank">Standard bank Joy of Jazz</a>
            <a class="nav-link" (click)="onNavigateToSpectacularConcert()" style="cursor: pointer;">Spectacular Concert</a>
          </nav>
        </div>
        <div class="col-lg-3">
          <nav class="nav flex-column align-items-lg-end align-items-sm-start">
            <h6 class="nav-link p-t-2">Social Media</h6>
            <a class="nav-link active" href="https://twitter.com/hashtag/tmusicman" target="_blank">Twitter
              <i class="fab fa-twitter "></i>
            </a>
            <a class="nav-link active" href="https://web.facebook.com/officialtmusicman/" target="_blank">Facebook
              <i class="fab fa-facebook "></i>
            </a>
            <a class="nav-link active" href="https://www.instagram.com/joyofjazz_" target="_blank">Instagram
              <i class="fab fa-instagram"></i>
            </a>
            <a class="nav-link active" href="https://www.youtube.com/user/SBJOYOFJAZZ" target="_blank">Youtube
              <i class="fab fa-youtube "></i>
            </a>
          </nav>
        </div>
        <div class="col-lg-3">
          <nav class="nav flex-column align-items-lg-end align-items-sm-start">
            <h6 class="nav-link p-t-2">Useful Links</h6>
            <a class="nav-link" href="/contact-us">Contact Us</a>
            <a class="nav-link" href="/team">Team</a>
            <a class="nav-link" href="/about-us">About Us</a>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-sm-12">
          <p>Design By
            <a href="http://ganizaniconsultingservices.co.za/" target="_blank">Ganizani Consulting Services (Pty) Ltd</a>
          </p>
        </div>
        <div class="col-lg-6 col-sm-12 ">
          <p class="text-right">© T-Musicman 2018</p>
        </div>
      </div>
    </div>
  </div>
</footer>
